import React, { useCallback, useEffect, useRef } from "react";
import { Select } from "antd";
import "../EditableCellGrid.css";

function normalizeEditorValue(column, value, row) {
    if (column.normalize) return column.normalize(value, row);
    return value;
}

function getEditorOptions(column) {
    return column.editorOptions ?? {};
}

function getSelectPopupContainer(triggerNode) {
    // Keep the popup out of RDG's clipped cell while staying inside the modal's positioning context.
    return triggerNode?.closest?.(".ant-modal-content") || document.body;
}

const SelectCellEditor = ({ row, column, onRowChange, onClose }) => {
    const value = row[column.key] ?? undefined;
    const closedRef = useRef(false);
    const selectRef = useRef(null);
    const editorOptions = getEditorOptions(column);
    const options = editorOptions.selectOptions ?? column.options ?? [];

    useEffect(() => {
        selectRef.current?.focus?.();
    }, []);

    const commit = useCallback(
        (nextValue) => {
            if (closedRef.current) return;
            closedRef.current = true;
            const normalizedValue = normalizeEditorValue(column, nextValue, row);
            onRowChange({ ...row, [column.key]: normalizedValue }, true);
        },
        [column, onRowChange, row],
    );

    const closeWithoutCommit = useCallback(() => {
        if (closedRef.current) return;
        closedRef.current = true;
        onClose(false, true);
    }, [onClose]);

    return (
        <Select
            ref={selectRef}
            autoFocus
            defaultOpen
            allowClear={editorOptions.allowClear ?? column.allowClear}
            className="editable-cell-editor editable-cell-editor-select"
            getPopupContainer={getSelectPopupContainer}
            loading={editorOptions.loading ?? column.loading}
            optionFilterProp={editorOptions.optionFilterProp ?? column.optionFilterProp ?? "label"}
            options={options}
            placeholder={editorOptions.placeholder ?? column.placeholder ?? "请选择"}
            popupMatchSelectWidth={editorOptions.popupMatchSelectWidth ?? column.popupMatchSelectWidth}
            showSearch={editorOptions.showSearch ?? column.showSearch ?? true}
            value={value}
            onBlur={closeWithoutCommit}
            onChange={commit}
            onInputKeyDown={(event) => {
                if (event.key === "Escape") {
                    event.preventDefault();
                    closeWithoutCommit();
                }
            }}
        />
    );
};

export default SelectCellEditor;
